module.exports = __webpack_public_path__ + "2b04ac04605821d246d30a15d5ff955f.svg";